// extracted by mini-css-extract-plugin
export var avatar = "_4y-3";
export var avatarContainer = "_4y-2";
export var avatarSpacer = "_4y-5";
export var avatarSpacerContainer = "_4y-4";
export var avatarStackContainer = "_4y-1";
export var bubble = "_4y-0";
export var remainderBubble = "_4y-6";